import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';
import { UserService } from '../modules/configuracoes/usuario/Service';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

const service = new UserService();

export default function RestorePassword() {
    const navigate = useNavigate();
    const { errorSnackbar, successSnackbar } = useAppContext();

    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [code, setCode] = useState('');
    const [uid, setUid] = useState('');

    const { image } = useAppContext();

    useEffect(() => {
        const uid = searchParams.get('uid');
        const codeParam = searchParams.get('code');

        if (uid && codeParam) {
            setUid(uid);
            setCode(codeParam);
        } else {
            navigate('/');
        }
    }, [searchParams]);

    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            errorSnackbar('As senhas não correspondem.');
            return;
        }

        setLoading(true);
        try {
            const response = await service.recoverPassword({
                uid, code, password,
            });

            successSnackbar('Senha alterada com sucesso!');
            await signInWithEmailAndPassword(auth, response?.data?.email, password);
            navigate('/');
            window.location.reload();
        } catch (error) {
            console.error(error);
            errorSnackbar('Ocorreu um erro ao alterar senha.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center min-h-screen bg-base-200/60">
            <div className="mx-auto w-full bg-base-100 rounded-lg shadow border border-base-200 md:mt-0 sm:max-w-md xl:p-0">
                <img src={image} alt="Logo" className="h-10 mx-auto mt-2" />
                <div className="text-lg px-2 pt-6 text-center text-base-content">
                    Crie uma nova senha!
                </div>
                <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                    <form className="space-y-4 md:space-y-6" onSubmit={onSubmit}>
                        <div>
                            <label
                                htmlFor="password"
                                className="block mb-2 text-sm font-medium text-base-content"
                            >
                                Senha
                            </label>
                            <input
                                type="password"
                                name="password"
                                id="password"
                                disabled={loading}
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="input input-bordered w-full"
                                required
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="confirmPassword"
                                className="block mb-2 text-sm font-medium text-base-content"
                            >
                                Confirmar Senha
                            </label>
                            <input
                                type="password"
                                name="confirmPassword"
                                id="confirmPassword"
                                disabled={loading}
                                placeholder="••••••••"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="input input-bordered w-full"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-primary w-full"
                        >
                            {loading ? <span className="loading loading-spinner loading-sm" /> : 'Confirmar'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
